import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { Screw } from "../../../../http/deckDesigner/types/screws";
import useDeckScrewsApi from "../../../../http/deckDesigner/useScrews";
import ScrewForm from "./ScrewForm";

const AdminScrews: FC = () => {
  const i18n = useI18n();
  const screwsApi = useDeckScrewsApi();
  const unitMm = i18n.translation.common.unitMm;

  return (
    <AdminCrudTable<Screw>
      filterPrefix="screws"
      useList={screwsApi.useDeckScrews}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.code}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.description}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.screwFamilies.singular}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.length}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.screwHeadHeight}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.screwDiameter}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.item.code}</TableCell>
          <TableCell>{item.item.description}</TableCell>
          <TableCell>{item.screwFamily.name}</TableCell>
          <TableCell>
            {item.length} {unitMm}
          </TableCell>
          <TableCell>
            {item.screwHeadHeight} {unitMm}
          </TableCell>
          <TableCell>
            {item.screwDiameter} {unitMm}
          </TableCell>
        </>
      )}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) => screwsApi.updateDeckScrewVisibility(item.item.id, { visibility }),
        updateOrder: (item, order) => screwsApi.updateDeckScrewOrder(item.item.id, { order }),
      }}
      onDelete={(item) => screwsApi.deleteDeckScrew(item.item.id)}
      deleteTitle={i18n.translation.deckDesignerModule.screws.singular}
      canAdd
      renderForm={(item, onClose) => <ScrewForm screw={item} onClose={onClose} />}
    />
  );
};

export default AdminScrews;
